<script>
import Modal from '../../Modal.vue';

export default {
  components: {
    Modal,
  },
  props: {
    show: Boolean,
    onClose: { type: Function, default: () => {} },
    onConfirm: { type: Function, default: () => {} },
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    messageValue: { type: String, default: '' },
    confirmText: { type: String, default: '' },
    rejectText: { type: String, default: '' },
    // Opcional e `false` por padrao: quem confirma de forma sincrona segue sem
    // passar nada. So serve a quem confirma contra a rede, onde o clique fica
    // sem resposta visivel enquanto a requisicao corre.
    isLoading: { type: Boolean, default: false },
    // Z-index da modal. Usar valores maiores para aparecer sobre outras
    // modais (ex: confirmação sobre modal de gerenciar pastas).
    zIndex: { type: Number, default: 10050 },
  },
};
</script>

<!-- eslint-disable vue/no-mutating-props -->
<template>
  <Modal :show.sync="show" :on-close="onClose" :z-index="zIndex">
    <woot-modal-header
      :header-title="title"
      :header-content="message"
      :header-content-value="messageValue"
    />
    <div class="flex items-center justify-end gap-2 p-8">
      <woot-button
        variant="clear"
        class="action-button"
        :is-disabled="isLoading"
        @click="onClose"
      >
        {{ rejectText }}
      </woot-button>
      <woot-button
        color-scheme="alert"
        class="action-button"
        variant="smooth"
        :is-loading="isLoading"
        :is-disabled="isLoading"
        @click="onConfirm"
      >
        {{ confirmText }}
      </woot-button>
    </div>
  </Modal>
</template>

<style lang="scss" scoped>
.action-button {
  max-width: var(--space-giga);
}
</style>
